import { ReshapedSponsors, reshapeSponsorsToObj } from './reshape';
import { client } from '../';
import { useQuery } from 'react-query';
import { useMemo } from 'react';
import { SponsorsResponseType } from './types';

type UseSponsors = (eventId: number) => {
    data: ReshapedSponsors | null;
    error: Error;
    isLoading: boolean;
    isSuccess: boolean;
};

export async function fetchSponsors(eventId: number) {
    return (await client().get(`/api/v1/organizer/event/${eventId}/partners`))
        .data as SponsorsResponseType;
}

const useSponsors: UseSponsors = eventId => {
    const { data, error, isLoading, isSuccess } = useQuery<SponsorsResponseType, Error>(
        ['sponsors', eventId],
        () => fetchSponsors(eventId),
        {
            enabled: !!eventId,
        }
    );

    return useMemo(
        () => ({
            data: data ? reshapeSponsorsToObj(data) : {},
            error,
            isLoading,
            isSuccess,
        }),
        [data, error, isLoading, isSuccess]
    );
};

export default useSponsors;
